module.exports = __webpack_public_path__ + "static/media/comment7_1.4c809743.png";